<template>
	<nut-navbar
		class="navbar"
		title="软件服务费"
		leftShow
		@on-click-back="goBack"
	>
		<template #right>
			<span class="color-white" @click="$router.push('/bill')">账单</span>
		</template>
	</nut-navbar>
	<div class="container">
		<div class="info">
			<div class="row">
				<span class="label">商品</span>
				<div class="value">多动屏服务年费</div>
			</div>
			<div class="row">
				<span class="label">说明</span>
				<div class="value">
					试用期后，将收取一定的软件服务费。基础价格为每年168元/每设备。一次性付两年可享三年服务，付三年则终身使用。如有问题，请在QQ群中向运营人员咨询。
				</div>
			</div>
			<div class="row">
				<span class="label">设备名</span>
				<div class="value">{{ devfeeData.name }}</div>
			</div>
			<div class="row">
				<span class="label">设备编号</span>
				<div class="value">{{ devfeeData.device_num }}</div>
			</div>
			<div class="row">
				<span class="label">原服务截止日</span>
				<div class="value value-date">{{ devfeeData.end_date }}</div>
			</div>
		</div>
		<nut-cell-group style="margin-bottom: 10px">				
			<nut-cell
				class="cell cell-desc"
				title="续费后截止日"
				:desc="endDate"
			>
			</nut-cell>
			<nut-cell class="cell" title="续费单价(年)" :desc="'¥' + price">
			</nut-cell>		
			<nut-cell
				class="cell-grey"
				@click="pickerShow = true"
				title="续费年限"
				:desc="selectedYearDesc"
				is-link
			>
			</nut-cell>
		</nut-cell-group>

		<div>
			<nut-cell
				class="cell cell-size"
				title="总金额(元)"
				:desc="'¥' + totalPrice"
			></nut-cell>
			<nut-grid :column-num="2">
				<nut-grid-item @click="$router.push('/reset')">
					<span class="reset">重置与解绑</span>
				</nut-grid-item>
				<nut-grid-item @click="handlePay">
					<span class="pay">支付</span>
				</nut-grid-item>
			</nut-grid>
		</div>
		<help-text-tip
			@click="handleOpenDialog(SERVICE_FEE_HELP)"
		></help-text-tip>
	</div>

	<nut-picker
		:modelValue="selectYear"
		v-model:visible="pickerShow"
		:columns="yearColumns"
		title="续费年限"
	>
	</nut-picker>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { Toast } from '@nutui/nutui';
import dayjs from 'dayjs';
import { HelpTextTip } from '@/components';
import useDialog from '@/hooks/useDialog';
import useNavigate from '@/hooks/useNavigate';
import { devfeeApi } from '@/apis';
import { yearColumns } from '@/constants/pickerColumns';
import { SERVICE_FEE_HELP } from '@/constants/tiptype';

const price = 168;
export default {
	name: 'Devfee',
	components: {
		HelpTextTip,
	},
	setup() {
		const devfeeData = ref({});
		const pickerShow = ref(false);
		const selectYear = ref(['1']);
		const selectedYearDesc = computed(() => {
			return yearColumns.filter(
				(year) => year.value == selectYear.value[0]
			)[0].text;
		});
		const totalPrice = computed(() => {
			return selectYear.value[0] * price;
		});

		const { goBack, push } = useNavigate();
		const { handleOpenDialog } = useDialog();

		const getData = async () => {
			const res = await devfeeApi.devfee_load_data();
			devfeeData.value = res;
		};

		const handlePay = async () => {
			Toast.loading('等待跳转中...');
			const res = await devfeeApi.devfee_pay({
				product: selectYear.value[0],
				amount: totalPrice.value * 100, // 单位分
			});
			Toast.hide();
			push(`/pay?paymentid=${res.wx_payment_id}`);
		};

		const endDate = computed(() => {
			const originEndDate = devfeeData.value.end_date;
			if (!originEndDate) return '';
			const d = originEndDate.replace(/-/g, '/');
			const isExpired = dayjs().isBefore(dayjs(d));
			let year = +selectYear.value[0];
			if (year === 3) {
				return '2099-12-31';
			}
			year = year === 2 ? 3 : year;
			if (isExpired) {
				// 没过期
				return dayjs(d)
					.add(year * 365, 'day')
					.format('YYYY-MM-DD');
			} else {
				// 过期
				return dayjs()
					.add(year * 365, 'day')
					.format('YYYY-MM-DD');
			}
		});

		onMounted(() => {
			getData();
		});

		return {
			price,
			totalPrice,
			yearColumns,
			selectYear,
			selectedYearDesc,
			devfeeData,
			pickerShow,
			SERVICE_FEE_HELP,
			goBack,
			handleOpenDialog,
			handlePay,
			endDate,
		};
	},
};
</script>

<style lang="scss" scoped>
.container {
	overflow: hidden;
	background: $bg_color;
}
.color-white {
	color: #fff;
}
.info {
	background: #fff;
	padding: 10px 16px;
	.row {
		@include flex-center;
		font-size: 12px;
		line-height: 1.6;
		color: #999;
		.label {
			align-self: flex-start;
		}
		.value {
			padding-left: 20px;
			flex: 1;
			text-align: right;

			&-date {
				color: #e64340;
				font-weight: 600;
			}
		}

		& + .row {
			margin-top: 12px;
		}
	}
}
.cell {
	:deep(.nut-cell__value) {
		color: $base-font-color;
	}

	&-size {
		:deep(.nut-cell__value) {
			font-weight: 500;
			font-size: $medium-font-size;
		}
	}

	&-grey {
		:deep(.nut-cell__value) {
			color: $grey-font-color;
		}
	}

	&-desc {
		:deep(.nut-cell__value) {
			color: #07c160;
		}
	}
}
.reset {
	color: #999;
}
.pay {
	color: $primary-color;
}
</style>
